export enum TreeOptions {
    Category = "category",
    Oe = "oe",
}
